import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateWonCar } from '../api';
import { type UpdateWonCarDto } from '../types';

/** Query key for the admin won-cars list. */
export const WON_CARS_QUERY_KEY = ['won-cars'] as const;

/**
 * PATCH a won car (financials or delivery status) then refresh the list — the
 * admin equivalent of the web `useUpdateWonCarMutation` + tag invalidation.
 */
export function useUpdateWonCar() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, updates }: { id: string; updates: UpdateWonCarDto }) =>
      updateWonCar(id, updates),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: WON_CARS_QUERY_KEY });
    },
  });
}
